// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2HdsE","gfeWrapper":"CalendarEvent_gfeWrapper__3DKnq"};